import groq from 'groq'

import { frameBuilderImageFragment } from './image'

export const frameBuilderTextureFragment = groq`
  ...,
  image {
    ${frameBuilderImageFragment}
  },
  icon {
    ${frameBuilderImageFragment}
  },
`

const frameBuilderProductTextureFragment = groq`
  _id,
  sku,
  title,
`

export const frameBuilderTextureObjectFragment = groq`
  "textures": *[
    _type == "frameBuilderTexture" &&
    locale == $locale
  ]
    | order(order asc)
  {
    ${frameBuilderTextureFragment}
  },
`

export const frameBuilderProductTextureObjectFragment = groq`
  "textures": *[
    _type == "frameBuilderTexture" &&
    locale == $locale
  ]
    | order(order asc)
  {
    ${frameBuilderProductTextureFragment}
  },
`
